import { render, staticRenderFns } from "./set-new-password.vue?vue&type=template&id=34a4eb7e"
import script from "./set-new-password.vue?vue&type=script&lang=js"
export * from "./set-new-password.vue?vue&type=script&lang=js"
import style0 from "./set-new-password.vue?vue&type=style&index=0&id=34a4eb7e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports